﻿$.fn.dxCtrlPlanitiReunionOrgaDetail = function custom_dxCtrlPlanitiReunionOrgaDetail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlplanitireunionorgadetail dx-ctrl");
        this.createInstance(new cdxCtrlPlanitiReunionOrgaDetail(this, option));
    }
    return this;
}

window.cdxCtrlPlanitiReunionOrgaDetail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var planitiReunion = option.dataPlanitiReunion.planiti_reunion[0]

        if (option.dataPlanitiReunion.planiti_reunion_orga.length > 1) {
            $("<hr/>").appendTo(container)
            option.dataPlanitiReunion.planiti_reunion_orga.forEach(function (planitiReunionOrga, idx) {
                mRempliPlanitiReunionOrga(planitiReunionOrga, planitiReunion, idx + 1)
                $("<hr/>").appendTo(container)
            })
        } else {
            var planitiReunionOrga = option.dataPlanitiReunion.planiti_reunion_orga[0]
            mRempliPlanitiReunionOrga(planitiReunionOrga, planitiReunion)
        }

    }

    function mRempliPlanitiReunionOrga(planitiReunionOrga, planitiReunion, Numero) {
        if (planitiReunionOrga.date_annulation != null) {
            //La réunion est annulé
            var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
            $("<div style='font-weight:bold;font-size:140%;color:red;'>Cette réunion a été annulée le " + DevExpress.localization.formatDate(planitiReunionOrga.date_annulation, "eeee d MMMM yyyy") + " à " + DevExpress.localization.formatDate(planitiReunionOrga.date_annulation, "HH:mm") + "</div>").appendTo($DivValide)
            container.css("text-decoration", "line-through")
        }

        var $Div = $("<div style='padding:10px 0;'/>").appendTo(container)

        //$Div.css("text-decoration", ((planitiReunionOrga.date_annulation != null || planitiReunion.date_debut < parametre.dateNow) ? "line-through" : ""))
        //$("<div style='font-weight:bold;font-size:120%;'>Rendez-vous le <b>" + DevExpress.localization.formatDate(planitiReunion.date_debut, "eeee d MMMM yyyy") + "</b> de <b><u>" + DevExpress.localization.formatDate(planitiReunion.date_debut, "HH:mm") + "</u></b> à <b><u>" + DevExpress.localization.formatDate(planitiReunion.date_fin, "HH:mm") + "</u></b></div>").appendTo($Div)

        $("<div style='font-weight:bold;font-size:140%;margin-bottom:5px;' class='dx-theme-accent-as-text-color'>Participant" + ((typeof Numero != 'undefined') ? " #" + Numero : "") + "</div>").appendTo($Div)
        if (typeof planitiReunionOrga.orga_nom_societe != 'undefined' && planitiReunionOrga.orga_nom_societe != null && planitiReunionOrga.orga_nom_societe.length > 0) {
            $("<div><span style='opacity:0.3'>Société:</span> " + planitiReunionOrga.orga_nom_societe + "</div>").appendTo($Div)
        }
        if (typeof planitiReunionOrga.orga_nom_prenom != 'undefined' && planitiReunionOrga.orga_nom_prenom != null && planitiReunionOrga.orga_nom_prenom.length > 0) {
            $("<div><span style='opacity:0.3'>Nom & prénom:</span> " + planitiReunionOrga.orga_nom_prenom + "</div>").appendTo($Div)
        }
        if (typeof planitiReunionOrga.orga_adresse_email != 'undefined' && planitiReunionOrga.orga_adresse_email != null && planitiReunionOrga.orga_adresse_email.length > 0) {
            $("<div><span style='opacity:0.3'>Adresse email:</span> <u>" + planitiReunionOrga.orga_adresse_email + "</u></div>").appendTo($Div)
        }
        if (typeof planitiReunionOrga.orga_tel_fixe_sms != 'undefined' && planitiReunionOrga.orga_tel_fixe_sms != null && planitiReunionOrga.orga_tel_fixe_sms.length > 0) {
            $("<div><span style='opacity:0.3'>Téléphone fixe:</span> " + planitiReunionOrga.orga_tel_fixe_sms + "</div>").appendTo($Div)
        }
        if (typeof planitiReunionOrga.orga_tel_mobile_sms != 'undefined' && planitiReunionOrga.orga_tel_mobile_sms != null && planitiReunionOrga.orga_tel_mobile_sms.length > 0) {
            $("<div><span style='opacity:0.3'>Téléphone mobile:</span> " + planitiReunionOrga.orga_tel_mobile_sms + "</div>").appendTo($Div)
        }
        if (typeof planitiReunionOrga.orga_site_web != 'undefined' && planitiReunionOrga.orga_site_web != null && planitiReunionOrga.orga_site_web.length > 0) {
            $("<div><span style='opacity:0.3'>Site web:</span> <u>" + planitiReunionOrga.orga_site_web + "</u></div>").appendTo($Div)
        }
        if ((typeof planitiReunionOrga.orga_ad1 != 'undefined' && planitiReunionOrga.orga_ad1 != null && planitiReunionOrga.orga_ad1.length > 0) ||
            (typeof planitiReunionOrga.orga_ville != 'undefined' && planitiReunionOrga.orga_ville != null && planitiReunionOrga.orga_ville.length > 0) ||
            (typeof planitiReunionOrga.orga_pays != 'undefined' && planitiReunionOrga.orga_pays != null && planitiReunionOrga.orga_pays.length > 0)) {
            var adr = new cAdresse({
                ad1: planitiReunionOrga.orga_ad1,
                ad2: planitiReunionOrga.orga_ad2,
                ad3: planitiReunionOrga.orga_ad3,
                cp: planitiReunionOrga.orga_cp,
                ville: planitiReunionOrga.orga_ville,
                cedex: "",
                dpt: planitiReunionOrga.orga_dpt,
                region: planitiReunionOrga.orga_region,
                pays: planitiReunionOrga.orga_pays,
                latitude: planitiReunionOrga.orga_latitude,
                longitude: planitiReunionOrga.orga_longitude,
                normalise: planitiReunionOrga.orga_normalise
            })
            $("<div><span style='opacity:0.3'>Adresse postale:</span> " + adr.mGetLibelleLong() + "</div>").appendTo($Div)
        }

        if ((planitiReunionOrga.text_info != null && planitiReunionOrga.text_info.length > 0) ||
            (typeof option.dataPlanitiReunion.lst_file != 'undefined' && option.dataPlanitiReunion.lst_file.length > 0)) {
            $("<div style='font-weight:bold;font-size:100%;margin:25px 0 5px 0;' class='dx-theme-accent-as-text-color'>Information complémentaires</div>").appendTo($Div)
            if (typeof option.dataPlanitiReunion.lst_file != 'undefined' && option.dataPlanitiReunion.lst_file.length > 0) {
                option.dataPlanitiReunion.lst_file.forEach(function (o) {
                    var $A = $("<div>🔗 <a href='javascript:void(0)'>" + o.nom + "</a></div>").appendTo($Div)
                    $A.on("click", function (e) {
                        option.bddCtrl.mAjaxCall({
                            command: "getfichierjointplanitireunion",
                            id:o.id_planiti_reunion_fichier
                        }, function (data) {
                            if (typeof data.url != 'undefined') {
                                window.open(data.url,"_blank")
                            }
                        })
                    })
                })
            }
            if (planitiReunionOrga.text_info != null && planitiReunionOrga.text_info.length > 0) {
                $("<div style='font-style:italic'>" + ((planitiReunionOrga.text_info == null || planitiReunionOrga.text_info.length == 0) ? "(aucune information complémentaire)" : planitiReunionOrga.text_info) + "</div>").appendTo($Div)
            }
        }

        //lien réunion orga
        var url = parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + planitiReunion.id_planiti + "/" + planitiReunion.id_planiti_reunion + "/" + planitiReunionOrga.id_planiti_reunion_orga + "/0/0/planiti"
        $("<div style='margin-top:25px;font-weight:bold;font-size:100%;margin-bottom:5px;' class='dx-theme-accent-as-text-color'>Lien sur votre réunion</div>").appendTo($Div)
        $("<a href='" + url + "' target='_blank'>" + url + "</a>").appendTo($Div)

        //button
        if (option.showBt) {
            var $Table = $("<table style='width:100%;margin-top:35px;'/>").appendTo($Div)
            var $Tr = $("<tr/>").appendTo($Table)
            if (planitiReunionOrga.date_annulation == null) {
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: ((option.dataPlanitiReunion.planiti[0].nbre_organisateur == 1) ? "Annuler la réunion" : "Annuler ma participation à la réunion"),
                    onClick: function (e) {
                        option.onDemandeAnnulation()
                    }
                })
                if (option.dataPlanitiReunion.planiti[0].nbre_organisateur == 1) {
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Reprogrammer la réunion",
                        onClick: function (e) {
                            option.onDemandeReprogrammation()
                        }
                    })
                }
            }
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        }

    }

    this.element = function () { return container; }

    mConstruit();
}